import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './TalukaLayout.css';

const NAV_ITEMS = [
  { path: '/taluka/dashboard',   label: 'डॅशबोर्ड',          icon: '📊' },
  { path: '/taluka/gps',         label: 'ग्रामपंचायती',      icon: '🏘️' },
  { path: '/taluka/complaints',  label: 'तक्रारी',           icon: '📢' },
  { path: '/taluka/citizens',    label: 'नागरिक',            icon: '👥' },
  { path: '/taluka/population',  label: 'लोकसंख्या व आकडेवारी',icon: '📈' },
  { path: '/taluka/staff',       label: 'कर्मचारी यादी',     icon: '👔' },
  { path: '/taluka/notices',     label: 'सूचना',             icon: '📋' },
  { path: '/taluka/facilities',  label: 'सुविधा',            icon: '🏥' },
  { path: '/taluka/businesses',  label: 'व्यवसाय',           icon: '🏪' },
];

export default function TalukaLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/taluka/login'); };

  const roleLabel = {
    tahashil_officer: 'तहसीलदार',
    sdo_officer: 'उपविभागीय अधिकारी',
  }[user?.role] || user?.role?.replace(/_/g, ' ');

  return (
    <div className="taluka-layout">
      {sidebarOpen && <div className="taluka-overlay" onClick={() => setSidebarOpen(false)} />}

      <aside className={`taluka-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="taluka-sidebar-header">
          <div className="taluka-sidebar-logo">🏛️</div>
          <div>
            <h2>तालुका पोर्टल</h2>
            <p>{user?.taluka ? `${user.taluka} तालुका` : 'सर्व ग्रामपंचायती'}</p>
          </div>
        </div>

        <nav className="taluka-nav">
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `taluka-nav-link${isActive ? ' active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="taluka-main">
        <header className="taluka-header">
          <div className="taluka-header-left">
            <button className="taluka-hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
            <div>
              <span className="taluka-header-title">डिजिटल ग्रामपंचायत पोर्टल</span>
              <span className="taluka-header-sub"> — तालुका प्रशासन</span>
            </div>
          </div>
          <div className="taluka-header-right">
            <span className="taluka-user-badge">
              <strong>{user?.full_name}</strong>
              <em>{roleLabel}</em>
            </span>
            <button onClick={handleLogout} className="taluka-logout-btn">बाहेर पडा</button>
          </div>
        </header>

        <main className="taluka-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
